import { render, staticRenderFns } from "./FiltrosNotasPendentes.vue?vue&type=template&id=66540fce&scoped=true&"
import script from "./FiltrosNotasPendentes.vue?vue&type=script&lang=js&"
export * from "./FiltrosNotasPendentes.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosNotasPendentes.vue?vue&type=style&index=0&id=66540fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66540fce",
  null
  
)

export default component.exports